

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth, AuthProvider } from "../contexts/AuthProvider";

import NotFound from "../pages/404/notFounds";
import Login from "../pages/login/login";
import { useEffect } from "react";
import AdminListage from "../pages/adminListage/adminListage";
import UserRegister from "../pages/userRegister/userRegister";
import LogsPathfind from "../pages/logsPathfind/logsPathfind";
import LogsSankhya from "../pages/logsSankhya/logsSankhya";

function PrivateRoute({ element: Element, ...rest }) {
  const { token } = useAuth();

  useEffect(() => {
    
  }, [token]);

  return token ? <Element {...rest} /> : <Navigate to="/login" />;
}

export default function Rotas() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />

          {/* Utilize PrivateRoute diretamente nas rotas desejadas */}
          <Route
            path="/user"
            element={<PrivateRoute element={AdminListage} />}
          />
          <Route
            path="/user_cadastrar"
            element={<PrivateRoute element={UserRegister} />}
          />
          <Route
            path="/logs_pathfind"
            element={<PrivateRoute element={LogsPathfind} />}
          />
          <Route
            path="/logs_sankhya"
            element={<PrivateRoute element={LogsSankhya} />}
          />
        



          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}